import { Unit } from '@philips-internal/oswald-ui-constants';
import { RenderEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isFunction } from '@philips-internal/oswald-ui-utils';
function getDynamicContent(data, entry = '', type, onDynamicContentRender) {
    let content = null;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const defaultFunction = (_) => null;
    let renderFn = defaultFunction;
    const render = (fn) => {
        renderFn = fn;
    };
    if (onDynamicContentRender) {
        onDynamicContentRender(new RenderEvent({ data, entry, render, type }));
    }
    if (renderFn !== defaultFunction && isFunction(renderFn)) {
        content = renderFn(data);
    }
    return content;
}
function fitPredefinedSizeValue(value) {
    const splittedValue = value.split(/(px|%)/);
    const numberValue = Number(splittedValue[0]);
    const unit = splittedValue[1];
    if (unit === Unit.PX) {
        return numberValue;
    }
    return value;
}
function validateChartSizes(height, width) {
    return !(typeof height === 'number' && typeof width === 'number');
}
export { getDynamicContent, fitPredefinedSizeValue, validateChartSizes, };
//# sourceMappingURL=base-chart-utils.js.map